import React from 'react'

export default function ProgramMembershipSection() {
    return (
        <div style={{
            border: '1px solid #e2e4e9',
            borderRadius: 6,
            marginBottom: 16
        }}>
            <div
                style={{
                    borderBottom: '1px solid #e2e4e9',
                    padding: 8,
                    background: '#f0f2f44d',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                }}
            >
                {/* <CommentOutlined /> */}
                <span style={{
                    fontWeight: 600,
                    fontFamily: 'tradeGothic',
                    fontSize: 14
                }}>
                    Programs & Memberships
                </span>
            </div>
            <div style={{ padding: 8 }}>
                All programs and memberships rewards associated with both profiles will be merged into the surviving profile.
                However, memberships will have to be renewed manually from the next billing cycle onwards             </div>
        </div>
    )
}
